// @flow
export default function asNull (value: mixed): ?any {
  if (value == null) {
    return null
  }

  return value
}
